/** Boolean из UniData / XML / плоской строки TreeTable. `null` — поля нет. */
export function coerceTreeTableBoolean(value: unknown): boolean | null {
  if (value == null || value === '') return null
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') {
    if (value === 1) return true
    if (value === 0) return false
    return null
  }
  if (typeof value === 'object' && value !== null && 'value' in value) {
    return coerceTreeTableBoolean((value as { value?: unknown }).value)
  }
  const s = String(value).trim().toLowerCase()
  if (s === 'true' || s === '1') return true
  if (s === 'false' || s === '0') return false
  return null
}

export function coerceTreeTableBooleanOr(
  value: unknown,
  fallback: boolean,
): boolean {
  const coerced = coerceTreeTableBoolean(value)
  return coerced == null ? fallback : coerced
}
